




























































































































































































import { Component, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { resourceItem } from '@/api/res'
declare var PhotoSphereViewer: any
@Component
export default class ResourceDetail extends ViewBase {
  @Prop({ type: Number, default: 0 }) id!: number
  item: any = {}
  lang: any = {}
  imgurl = ''
  viewer: any = {}
  columns: any = []
  isBofang: boolean = false
  is360Bofang: boolean = false

  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  get isPanoramaImage() {
    const item = this.item
    return item.file_type == 'image' && item.is_bokong == 1
  }
  get isPanoramaVideo() {
    const item = this.item
    return item.file_type == 'video' && item.is_bokong == 1
  }
  get isVRVideo() {
    const item = this.item
    return (item.file_type == 'video' && item.is_bokong == 0) || item.file_type == 'app'
  }

  get isPlaying() {
    if (!this.isVRVideo) {
      return false
    }
    const refPlayer: any = this.$refs.refPlayer
    return this.isVRVideo && !refPlayer.paused
  }

  created() {

    this.lang = this.i18n.vResItem
    const lang: any = this.lang
    this.fetch()

    this.columns = [
      {
        title: lang.module,
        className: 'col1',
        scopedSlots: { customRender: 'index' }
      },
      {
        title: lang.screenshot,
        className: 'col2',
        scopedSlots: { customRender: 'img' }
        // render: it => <img src={it.cover} />
      },
      {
        title: lang.coreContent,
        className: 'col3',
        dataIndex: 'intro'
      },
      {
        title: lang.duration,
        className: 'col4',
        dataIndex: 'duration'
      },
      {
        title: lang.control,
        className: 'col5',
        scopedSlots: { customRender: 'renderControl' }
        // render: it => this.renderControl(it),
      },
      {
        title: lang.interaction,
        className: 'col6',
        scopedSlots: { customRender: 'renderAction' }
      }
    ]
    this.$navigation.on('forward', (to: any, from: any) => {
      if (from.route.name != 'resourceDetail') {
        return
      }
      if (this.viewer && this.viewer.video) {
        // 关闭正在播放的视频
        this.viewer.stop()
      }
    })
  }

  beforeDestroy() {
    if (this.viewer && this.viewer.video) {
      // 关闭正在播放的视频
      this.viewer.stop()
    }
  }

  async fetch() {
    const query: any = {
      id: this.id
    }
    try {
      const { data } = await resourceItem(query)
      this.item = data.item
      this.imgurl = data.banner
      this.$nextTick(() => {
        if (this.isPanoramaImage) {
          this.initPanoramaImage()
        }
        if (this.isPanoramaVideo) {
          this.isBofang = true
          this.initPanoramaVideo()
        }
        // 视频
        if (this.isVRVideo) {
          this.isBofang = true
          const refPlayer: any = this.$refs.refPlayer
          const that = this
          refPlayer.addEventListener('play', () => {
            that.isBofang = false
          })
          refPlayer.addEventListener('pause', () => {
            that.isBofang = true
          })
        }
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  initPanoramaImage() {
    const player: any = this.$refs.refPlayer
    const that = this
    // console.log(player)
    if (player != null && this.isPanoramaImage) {
      player.innerHTML = ' '
      // console.log(viewer)
      this.viewer = new PhotoSphereViewer({
        container: player,
        panorama: that.item.image_url,
        // loading_img: '/lib/photo/assets/photosphere-logo.gif',
        loading_load: true,
        time_anim: false,
        navbar: ['zoom', 'fullscreen']
      })
    }
  }
  initPanoramaVideo() {
    const that = this
    const volume = false
    // const volumexx = "<i id='volumeee' class='iconfont icon-shengyin'></i>"
    // const navbar: any = ['playpause', 'duration', 'volume', 'markers', 'fullscreen']
    // console.log('showeye', showeye)
    const videoPlayer: any = this.$refs.refVideoPlayer
    // console.log(videoPlayer)
    if (videoPlayer != null && this.isPanoramaVideo) {
      videoPlayer.innerHTML = ' '
      this.viewer = new PhotoSphereViewer.Video({
        container: videoPlayer,
        video: [
          { source: that.item.video_url, resolution: 'HD' },
          { source: that.item.video_url, resolution: 'SD' }
        ],
        default_resolution: 'SD',
        muted: false,
        caption: 'openid.tiele',
        // loading_img: '/lib/photo/assets/photosphere-logo.gif',
        loading_load: true,
        navbar: ['playpause', 'duration', 'volume', 'fullscreen']
      })

      if (this.viewer) {
        this.is360Bofang = true
      }

      this.viewer.video.addEventListener('play', () => {
        that.is360Bofang = false
      })
      this.viewer.video.addEventListener('pause', () => {
        that.is360Bofang = true
      })
    }
    this.viewer.video.addEventListener('play', () => {
      that.isBofang = false
    })
    this.viewer.video.addEventListener('pause', () => {
      that.isBofang = true
    })
  }
  goeditCourse() {
    // const resList = (this.resList || []).map(({ rid, title, res_type }) => ({
    //   id: rid,
    //   title,
    //   res_type
    // }))
    // this.$store.commit('setPlayList', resList)
    // this.$router.push({ name: 'courseEdit', params: { id: this.id + '' } })
    this.$router.go(-1)
  }
  // 把课件 放到创建课程左侧列表
  joinlist() {
    const resList = this.$store.state.playList
    const thisres = {
      id: this.item.id,
      res_type: this.item.res_type,
      title: this.item.title
    }

    if (resList.find((ele: any) => ele.id === thisres.id)) {
      this.$message.warning(this.i18n.vResItem.added)
      this.$router.go(-1)
      return
    }
    resList.push(thisres)
    this.$store.commit('setPlayList', resList)
    this.$message.success(this.i18n.vAccountForm.operationSuccess)
    this.$router.go(-1)
  }

  goCourse() {
    const playAll = { title: this.item.title }
    this.$store.commit('setplayALL', playAll)
    const resList = ([this.item] || []).map(({ id, title, res_type }) => ({
      id,
      title,
      res_type
    }))
    this.$store.commit('setPlayList', resList)
    this.$router.push({
      name: 'playIndex',
      params: {
        id: this.id + ''
      }
    })
  }
  play360Video() {
    if (this.viewer) {
      // if (this.is360Bofang == true) {
      //   if (this.viewer.video) {
      //     this.viewer.stop()
      //   }
      // }
      if (this.is360Bofang == true) {
        if (this.viewer.video) {
          this.viewer.play()
        }
      }
    }
  }
  playVideo() {
    const refPlayer: any = this.$refs.refPlayer
    refPlayer.play()
    this.isBofang = false
  }

  playVRVideo() {
    this.viewer.play()
    this.isBofang = false
  }
}
